import React from 'react';

import { SkeletonContainer } from 'src/app/pages/starterDashboardV2/shared/components';

import type { Platform } from '../../../../shared/constants';
import { PlatformIcon } from '../../../common/PlatformIcon';

type Props = Readonly<{
	platform?: Platform;
}>;

export const SocialContentPreviewLoading: React.FC<Props> = ({ platform = 'instagram' }) => {
	return (
		<SkeletonContainer loading>
			<div
				data-platform={platform}
				data-testid={`placeholder-social-content-${platform}`}
				className="relative"
				aria-hidden="true"
			>
				<div className="relative rounded-2xl bg-[#E1DDE9] p-4">
					<PlatformIcon platform={platform} />
					<div className="w-[7.2rem] overflow-hidden rounded-xl border-2 border-white bg-white shadow-sm">
						<div className="h-18 w-full animate-pulse bg-[#E1DDE9]" />
						<div className="h-20 w-full bg-white p-3"></div>
					</div>
				</div>
			</div>
		</SkeletonContainer>
	);
};
